import React from 'react';
import { classNames } from '../atoms';

export type StackGap = 0 | 1 | 2 | 3 | 4 | 5;

export interface StackProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  gap?: StackGap;
}

const Stack: React.FC<StackProps> = ({
  as: Component = 'div',
  gap = 3,
  className,
  children,
  ...props
}) => (
  <Component className={classNames('d-grid', `gap-${gap}`, className)} {...props}>
    {children}
  </Component>
);

export default Stack;
